export default {
    dateHelperChips: {
        toolbarAria: 'Pomočniki za obseg datumov',
        applyDay: 'Uporabi dan',
        applyWeek: 'Uporabi teden (pon–ned)',
        applyWeekend: 'Uporabi vikend',
        applyMonth: 'Uporabi mesec',
        applyQuarter: 'Uporabi četrtletje',
        applyYear: 'Uporabi leto',
    },
}
